import React from 'react';
import RootSvg, { RootSvgProps } from '@/components/icons/RootSvg';

export default function SvgStar(props: RootSvgProps) {
  return (
    <RootSvg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4069_18742)">
        <path
          d="M4.96871 7.75012C4.92408 7.57709 4.83388 7.41918 4.70752 7.29282C4.58116 7.16646 4.42325 7.07626 4.25021 7.03162L1.18271 6.24062C1.13038 6.22577 1.08432 6.19425 1.05152 6.15085C1.01872 6.10744 1.00098 6.05453 1.00098 6.00012C1.00098 5.94572 1.01872 5.89281 1.05152 5.8494C1.08432 5.806 1.13038 5.77448 1.18271 5.75962L4.25021 4.96812C4.42319 4.92353 4.58106 4.83341 4.70742 4.70714C4.83377 4.58088 4.924 4.42307 4.96871 4.25012L5.75971 1.18262C5.77442 1.13008 5.80591 1.0838 5.84937 1.05082C5.89284 1.01785 5.9459 1 6.00046 1C6.05502 1 6.10809 1.01785 6.15155 1.05082C6.19502 1.0838 6.22651 1.13008 6.24121 1.18262L7.03171 4.25012C7.07635 4.42316 7.16654 4.58107 7.29291 4.70743C7.41927 4.83379 7.57718 4.92399 7.75021 4.96862L10.8177 5.75912C10.8705 5.77367 10.917 5.80513 10.9501 5.84866C10.9833 5.8922 11.0012 5.94541 11.0012 6.00012C11.0012 6.05484 10.9833 6.10805 10.9501 6.15159C10.917 6.19512 10.8705 6.22657 10.8177 6.24112L7.75021 7.03162C7.57718 7.07626 7.41927 7.16646 7.29291 7.29282C7.16654 7.41918 7.07635 7.57709 7.03171 7.75012L6.24071 10.8176C6.22601 10.8702 6.19452 10.9165 6.15105 10.9494C6.10759 10.9824 6.05452 11.0002 5.99996 11.0002C5.9454 11.0002 5.89234 10.9824 5.84887 10.9494C5.80541 10.9165 5.77392 10.8702 5.75921 10.8176L4.96871 7.75012Z"
          stroke="url(#paint0_linear_4069_18742)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 1.5V3.5"
          stroke="url(#paint1_linear_4069_18742)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 2.5H9"
          stroke="url(#paint2_linear_4069_18742)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2 8.5V9.5"
          stroke="url(#paint3_linear_4069_18742)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.5 9H1.5"
          stroke="url(#paint4_linear_4069_18742)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_4069_18742"
          x1="1.00098"
          y1="1"
          x2="11.0012"
          y2="1"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0050B3" />
          <stop offset="1" stopColor="#409EC8" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4069_18742"
          x1="10"
          y1="1.5"
          x2="11"
          y2="1.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0050B3" />
          <stop offset="1" stopColor="#409EC8" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4069_18742"
          x1="9"
          y1="2.5"
          x2="11"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0050B3" />
          <stop offset="1" stopColor="#409EC8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_4069_18742"
          x1="2"
          y1="8.5"
          x2="3"
          y2="8.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0050B3" />
          <stop offset="1" stopColor="#409EC8" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_4069_18742"
          x1="1.5"
          y1="9"
          x2="2.5"
          y2="9"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0050B3" />
          <stop offset="1" stopColor="#409EC8" />
        </linearGradient>
        <clipPath id="clip0_4069_18742">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </RootSvg>
  );
}
